import React from 'react';

const TextReveal = ({ children, className = '' }) => (
  <div className={`overflow-hidden ${className}`}>
    <div className="reveal-text">{children}</div>
  </div>
);

export default TextReveal;
